// extracted by mini-css-extract-plugin
export var lg = "_kb-7";
export var md = "_kb-6";
export var placeholderContainer = "_kb-1";
export var placeholderIcon = "_kb-2";
export var productImage = "_kb-0";
export var sm = "_kb-5";
export var xl = "_kb-8";
export var xs = "_kb-4";
export var xxs = "_kb-3";